import React, { Dispatch, FC, SetStateAction } from "react";
import { useOnChangeChildDispatch } from "utils/OnChange";
import { WidgetColorPicker } from "../WidgetThemeBuilder/WidgetColorPicker";
import { SearchWidgetBubbleTheme } from "./SearchWidgetTypes";

export interface SearchWidgetBubbleSectionThemeBuilderProps {
    readonly theme: SearchWidgetBubbleTheme | undefined;
    readonly defaultTheme: SearchWidgetBubbleTheme | undefined;
    readonly onChange: Dispatch<SetStateAction<SearchWidgetBubbleTheme>>;
}

const EMPTY_THEME: SearchWidgetBubbleTheme = {};

export const SearchWidgetBubbleSectionThemeBuilder: FC<SearchWidgetBubbleSectionThemeBuilderProps> = props => {
    const theme: SearchWidgetBubbleTheme = props.theme ?? EMPTY_THEME;
    const defaultTheme: SearchWidgetBubbleTheme = props.defaultTheme ?? EMPTY_THEME;

    const { onChange } = props;

    const handleBubbleColorChange = useOnChangeChildDispatch("background", onChange);

    return (
        <WidgetColorPicker key="bubbleColor" label="Background" value={theme.background} defaultValue={defaultTheme.background} onChange={handleBubbleColorChange} />
    );
};